import React, { HTMLAttributes } from 'react';
import { token } from '@atlaskit/tokens';
import Building from './building-functionality.svg';
import { css } from '@compiled/react';

const styles = css({
  maxHeight: '250px',
  padding: token('space.200'),
});

export const BuildingImage = (attributes: HTMLAttributes<object>) => <Building {...attributes} css={styles} />;

BuildingImage.displayName = 'BuildingImage';
